import { UserContext } from 'context';
import React, { useContext } from 'react'
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { FaCheckCircle } from 'react-icons/fa';
import { FaCaretDown, FaCaretUp, FaCheck } from 'react-icons/fa6';
import { PiSortAscending, PiSortDescending } from 'react-icons/pi';
import './sorting.css'

const SortingFilter = () => {

    const { invoiceFilters, setInvoiceFilters } = useContext(UserContext)

    const sortingArray = [
        { label: 'LR Number', value: 'lr_number' },
        { label: 'Invoice Number', value: 'invoice_number' },
        { label: 'Vehicle Number', value: 'vehicle_no' },
        { label: 'Invoice Date', value: 'invoice_date' },
        { label: 'Dispatch Date', value: 'dispatch_date' },
        { label: 'Indent Date', value: 'indent_date' },
        { label: 'Indent Number', value: 'indent_number' },
    ]

    return (
        <>
            <div className='__sortNw_bxs'>
                <DropdownButton className='sortDropdown_btn' title={sortingArray?.find((el) => el?.value === invoiceFilters?.sort_field)?.label}>
                    {
                        sortingArray?.map((el, idx) => {
                            return (
                                <React.Fragment>
                                    <Dropdown.Item className={el?.value === invoiceFilters?.sort_field ? 'sortItem_ajn itemHigh_ajn' : 'sortItem_ajn'} key={el?.label + idx} onClick={(e) => setInvoiceFilters({ ...invoiceFilters, sort_field: el?.value })}>
                                        <div className='flex_WithSpaceBwtn'>
                                            <div className='textColor_sort'>
                                                {el?.label}
                                            </div>
                                            {el?.value === invoiceFilters?.sort_field ? <FaCheck /> : <></>}
                                        </div>
                                    </Dropdown.Item>
                                </React.Fragment>
                            )
                        })
                    }
                </DropdownButton>
                <button className="btn_avnts" onClick={(e) => setInvoiceFilters({ ...invoiceFilters, sort_order: invoiceFilters?.sort_order === 'asc' ? 'dsc' : 'asc' })}>
                    <span className="spn_avtRs">
                        {invoiceFilters?.sort_order === 'asc' ? <PiSortAscending /> : <PiSortDescending />}
                    </span>
                </button>
            </div>
        </>
    )
}

export default SortingFilter